var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.options, function(option, i) {
      return _c(
        "div",
        {
          key: option.value + "-" + i,
          staticClass: "form-check form-check-inline"
        },
        [
          _c("RadioButton", {
            attrs: {
              name: _vm.name,
              label: option.label,
              option: option.value,
              disabled: !_vm.canEdit
            },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }